import './z_header';
import '../css/z_category.less';
import banner from '../../libs/banner/banner';
import '../css/page.less';

// banner
if($('body').width()<768){
    banner.render({ bannerScale: 4/3 });
}else{
    banner.render({ bannerWidth: 1920, bannerHeight: 650 });
}